export default "__VITE_ASSET__BSFfUpz0__"